export function mailStatusLabel(status) {
  switch (status) {
    case "SENT":
      return "Gesendet";
    case "FAILED":
      return "Fehlgeschlagen";
    case "DISABLED":
      return "Deaktiviert";
    case "QUEUED":
      return "In Warteschlange";
    default:
      return status || "Unbekannt";
  }
}

export function mailEventLabel(eventType) {
  switch (eventType) {
    case "email.accepted":
      return "Vom Mail-Provider übernommen";
    case "email.delivered":
      return "Zugestellt";
    case "email.failed":
      return "Fehlgeschlagen";
    case "email.bounced":
      return "Unzustellbar";
    case "email.rejected":
      return "Abgelehnt";
    case "email.suppressed":
      return "Unterdrückt";
    case "email.complained":
      return "Beschwerde";
    case "email.opened":
    case "email.loaded":
      return "Öffnung erkannt";
    case "email.clicked":
    case "email.link.clicked":
      return "Klick erkannt";
    default:
      return "Ereignis";
  }
}

export function mailMessageTypeLabel(messageType) {
  switch (messageType) {
    case "super_admin_test":
      return "Testmail";
    case "runtime_webhook_test":
      return "Systemtest";
    case "tenant_invite":
      return "Einladung";
    case "public_lead_notification":
      return "Lead-Benachrichtigung";
    case "public_lead_confirmation":
      return "Formularbestätigung";
    default:
      return "E-Mail";
  }
}

export function mailSendToastMessage({ ok, isTest = false }) {
  if (ok) {
    return isTest
      ? "Testmail wurde erfolgreich gesendet."
      : "E-Mail wurde erfolgreich gesendet.";
  }
  return "E-Mail konnte nicht gesendet werden.";
}
